/* ws_as-seen-on — autoplay product UGC videos only while in view (IntersectionObserver),
   plus desktop pointer drag-to-scroll. Mirrors the theme's shoppable-layout slider pattern.
   Lightweight: no dependencies, no work until elements scroll into view. */
(function () {
  if (customElements.get('ws-as-seen-on')) return;

  var prefersReducedMotion =
    window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function lowPower() {
    try {
      return typeof window.isLowPowerDevice === 'function' && window.isLowPowerDevice();
    } catch (e) {
      return false;
    }
  }

  class WsAsSeenOn extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('.ws_as-seen-on__track');
      this.videos = Array.prototype.slice.call(this.querySelectorAll('video'));
      this.setupAutoplay();
      this.setupDrag();
    }

    setupAutoplay() {
      if (!this.videos.length) return;
      // Respect reduced-motion / low-power devices: leave the poster, don't autoplay.
      if (prefersReducedMotion || lowPower() || !('IntersectionObserver' in window)) return;

      var io = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            var video = entry.target;
            if (entry.isIntersecting && video.paused) {
              video.muted = true;
              video.playsInline = true;
              var p = video.play();
              if (p && typeof p.catch === 'function') p.catch(function () {});
            } else if (!entry.isIntersecting && !video.paused) {
              video.pause();
            }
          });
        },
        { threshold: 0.5 }
      );

      this.videos.forEach(function (video) {
        io.observe(video);
      });
      this._io = io;
    }

    setupDrag() {
      var track = this.track;
      if (!track) return;

      var self = this;
      var isDown = false;
      var startX = 0;
      var startScroll = 0;

      track.addEventListener('pointerdown', function (e) {
        if (e.pointerType === 'touch') return; // keep native touch scrolling
        isDown = true;
        startX = e.clientX;
        startScroll = track.scrollLeft;
        self.classList.add('ws_as-seen-on--grabbing');
      });

      function end() {
        isDown = false;
        self.classList.remove('ws_as-seen-on--grabbing');
      }

      track.addEventListener('pointerup', end);
      track.addEventListener('pointerleave', end);
      track.addEventListener('pointercancel', end);

      track.addEventListener('pointermove', function (e) {
        if (!isDown) return;
        track.scrollLeft = startScroll - (e.clientX - startX);
      });

      // Avoid native image drag interfering with the drag-scroll.
      track.addEventListener('dragstart', function (e) {
        e.preventDefault();
      });
    }

    disconnectedCallback() {
      if (this._io) this._io.disconnect();
    }
  }

  customElements.define('ws-as-seen-on', WsAsSeenOn);
})();
